import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from "@material-ui/core/styles";
import { useDispatch } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import MuiButton from "Components/MuiButton/MuiButton";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import Translator from "Languages/Utility/Translator";
import Input from "Components/Input/Input";
import { DialogActions } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import * as R from "ramda";
import { read } from "Helpers/LocalStorage";
import showNotify from "Helpers/Notify";
import { editSettingProject } from "Stores/actions/properties/ShopAction";
import ActionFormatter from "Components/Table/ActionFormatter/ActionFormatter";
import * as Icons from "react-bootstrap-icons";

export default function EditProjects({ row }) {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [formValid, setFormValid] = useState({});
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [checkValid, setCheckValid] = useState(false);

  const [controls, setControls] = useSetState({
    name: {
      type: "text",
      value: "",
      validation: {
        required: true,
      },
    },
  });

  const handleDialog = () => setOpenDialog(!openDialog);

  const onEnter = async () => {
    onClear();
  };

  const onClear = async () => {
    setCheckValid(false);
    setFormValid({ name: false });
    setControls({ name: { value: row.Name } });
  };

  const onExit = () => {
    setOpenDialog(false);
  };

  const setValue = async (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
  };

  const onFinish = async (e) => {
    e.preventDefault();
    if (
      !R.isEmpty(formValid) &&
      Object.values(formValid).every((item) => item === true)
    ) {
      const { name } = controls;
      try {
        const data = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          Name: name.value,
          Id: +row.Id,
        };
        setLoading(true);
        await dispatch(editSettingProject(data));
        onExit();
        setLoading(false);
      } catch (e) {
        showNotify({
          text: t("correctFormDataRequired"),
          customClass: "error",
        });
      }
    } else {
      setCheckValid(true);
    }
  };

  return (
    <>
      <ActionFormatter
        title={<Translator id="virayesh" />}
        icon={<Icons.Pencil size={17} />}
        className="warning-fill"
        onClick={handleDialog}
        disabled={!read("settingShopProject")?.accessUpdate}
      />
      <Dialog
        dir={direction}
        open={openDialog}
        TransitionProps={{ onEnter: onEnter, onExit: onExit }}
        onClose={handleDialog}
        fullWidth
        maxWidth="xs"
      >
        <div>
          <div className="dialogHeader">
            <p>{<Translator id={"virayesh"} />}</p>
          </div>
          <DialogContent id="content-dialog-manager">
            <BackDropLoading loading={loading} />
            <Grid container spacing={2}>
              {Object.keys(controls).map((key, index) => {
                return (
                  <Grid item xs={12} key={key + index}>
                    {controls[key].type === "text" && (
                      <Input
                        setValue={setValue.bind(this)}
                        value={controls[key].value}
                        name={key}
                        validation={controls[key].validation}
                        label={<Translator id={key} />}
                        type="text"
                        checkValid={checkValid && !formValid[key]}
                      />
                    )}
                  </Grid>
                );
              })}
            </Grid>
          </DialogContent>
          <DialogActions>
            <MuiButton
              loading={loading}
              color="primary"
              title={<Translator id="button_save" />}
              onClick={onFinish}
            />
            <MuiButton
              onClick={handleDialog}
              title={<Translator id="enseraf" />}
            />
          </DialogActions>
        </div>
      </Dialog>
    </>
  );
}
